module.exports = __webpack_public_path__ + "img/img_side_heart.664a79e7.png";